import React from 'react';
import Avatar from "../../../../../../components/Avatar";
import { createAvtarName, hasImage } from "../../../../../../utils/helpers";
import { currentUserId, isAdmin } from "../../../../../../utils/constants";

const UserAvatar = ({ 
  user, 
  isColabrotar, 
  selectedUsers, 
  filterUserById, 
  boardOwnerId 
}) => {
  const username = isColabrotar 
    ? `${user?.user?.first_name} ${user?.user?.last_name}`
    : user?.username;

  const userImage = isColabrotar ? user?.user?.user_image : user?.user_image;
  const profileColor = isColabrotar ? user?.user?.profile_color : user?.profile_color;
  const userId = user?.user_id;

  return (
    <Avatar
      key={`user-avtar-${userId}`}
      onClick={() => filterUserById(userId)}
      username={username}
      user_image={userImage}
      title={username}
      className={`header-avatar ${
        selectedUsers?.includes(String(userId)) ? "active-avtar" : ""
      }`}
      style={
        !hasImage(userImage) && {
          bgcolor: profileColor?.background,
          color: profileColor?.text,
        }
      }
      isAdmin={
        user?.is_admin ||
        userId === boardOwnerId ||
        (currentUserId() === userId && isAdmin())
      }>
      {createAvtarName(username)}
    </Avatar>
  );
};

export default UserAvatar; 